import React, { useState, useContext, useEffect } from "react";
import Stepper from "react-stepper-horizontal";
import UploadFile from "./Step1/Step1";
import LocationDetails from "./Step2/Step2";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext"; 
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";

/**
 * Component to render steps for bulk upload location master data
 * @param {Array<Object>} locationMasterList - master location data
 * @param {React.SetStateAction} setLocationMasterList -setter for location data
 * @param {Object} userDetails - details of the logged-in user (ASSUMED PROP)
 * @param {Object} companySettingData - company settings data (ASSUMED PROP)
 * @returns {JSX.Element} - rendered UI for stepper for bulk uploads
 */
const LocationUploadExcel = ({
  locationMasterList,
  setLocationMasterList,
  company_id,
  superAdmins,
  emailTemplate,
  onClose

}) => {
  const [step, setStep] = useState(0);
  const [uploadedData, setUploadedData] = useState([]);
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  useEffect(() => {
    TrackMixPanel({
      ModuleName: "masters",
      ScreenName: "location master",
      Definition: "user initiated location master bulk upload",
      Data: "none",
    });
  }, []); 

  return (
    <div>
      <Stepper
        steps={[
          { title: "Upload File" },
          { title: "Check Your Location Details" },
        ]}
        activeStep={step}
        completeColor={"#54a63a"}
        completeTitleColor={"#54a63a"}
        activeColor={"#393186"}
        activeTitleColor={"#393186"}
        titleFontSize={14}
        size={28}
        circleFontSize={14}
      />
      {step === 0 ? (
        <UploadFile
          step={step}
          setStep={setStep}
          uploadedData={uploadedData}
          setUploadedData={setUploadedData}
          company_id={company_id}
        />
      ) : null}
      {step === 1 ? (
        <LocationDetails
          step={step}
          setStep={setStep}
          uploadedData={uploadedData}
          setUploadedData={setUploadedData}
          locationMasterList={locationMasterList}
          setLocationMasterList={setLocationMasterList}
          company_id={company_id}
          emailTemplate={emailTemplate}
          superAdmins={superAdmins}
          onClose={onClose}
        />
      ) : null}
    </div>
  );
};

export default LocationUploadExcel;
